/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const semaglutideDose = useStore((state) => state.semaglutideDose);
  const setSemaglutideDose = useStore((state) => state.setSemaglutideDose);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.semaglutideDose.title')}</Title>
        <Text size='m' medium className='description' style={{ padding: '0' }}>
          {t('onboarding.semaglutideDose.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={semaglutideDose}
          onChange={(value: string) => {
            setSemaglutideDose(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'semaglutide-dose',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'0.25 mg'}>0.25 mg</Option>
          <Option value={'0.5 mg'}>0.5 mg</Option>
          <Option value={'1 mg'}>1 mg</Option>
          <Option value={'1.7 mg'}>1.7 mg</Option>
          <Option value={'2.4 mg'}>2.4 mg</Option>
          <Option value={'Not sure'}>{t('onboarding.semaglutideDose.notSure')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
